import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
import { theme } from '../../themes/theme.js';
export default css `
    ${componentStyles}

    .meessage {
        display: flex;
        ${theme.texts.cssBody('normal')};
        ${theme.colors.cssColor('text-default')};
    }
`;
//# sourceMappingURL=DeleteButton.styles.js.map